import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { clone } from 'shared/utility';
import FileUploader from 'components/FileUploader/FileUploader';
import CustomInput from 'components/CustomInput/CustomInputValidate';
import { IconButton } from '@material-ui/core';

const Documents2 = (props) => {

    const data = props.data;

    if (!data) return null;

    const documents = data.documents ? data.documents : [];

    const documents_with_file = documents.filter(f => {
        if (!f.rs_filename) return false;
        return true;
    })

    console.log('Documents2', props, data, documents);

    return (
        <div className={props.disabled ? 'no-click gray-bg' : ''}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    {!props.disabled && <Button color="primary" onClick={() => {
                        const newData = clone(data);
                        console.log('nd', newData)
                        if (!newData.documents) newData.documents = [];
                        newData.documents.push({
                            rs_filename: '',
                            description: ''
                        })

                        props.updateDataObj('documents', newData.documents);
                    }}>
                        ADD DOCUMENT
                    </Button>}
                    <hr />
                    {<div className="mt-20 mb-20">
                        {documents_with_file.length} Document(s)
                    </div>}
                    <GridContainer>
                
                    {
                        documents.map((f,i) => {
                            return <GridItem xs={12} sm={12} md={4} key={`${i}-fileform`}>
                            <div className="mr-20 mt-20">
                                {!f.rs_filename && <div style={{float:'right'}}><IconButton
                                onClick={() => {
                                    const newData = clone(data);
                                        if (!newData.documents) newData.documents = [];
                                        newData.documents = newData.documents.filter((ff,ii) => {
                                            if (ii === i) return false;
                                            return true;
                                        })
                                        props.updateDataObj('documents', newData.documents);
                                }}
                                ><i className="fa fa-trash red-text" style={{marginRight:20,fontSize:14}}></i></IconButton></div>}
                                <div className="boxed mr-20 mt-20">    
                                    <FileUploader 
                                        title={`File ${i+1}`}
                                        update={(val) => {
                                            const newData = clone(data);
                                            if (!newData.documents) newData.documents = [];
                                            newData.documents = newData.documents.map((ff,ii) => {
                                                if (ii === i) {
                                                    ff.rs_filename = val;
                                                    return ff;
                                                }
                                                return ff;
                                            })
                                            props.updateDataObj('documents', newData.documents);
                                        }}
                                        remove={() => {
                                            const newData = clone(data);
                                            if (!newData.documents) newData.documents = [];
                                            newData.documents = newData.documents.filter((ff,ii) => {
                                                if (ii === i) return false;
                                                return true;
                                            })
                                            props.updateDataObj('documents', newData.documents);
                                        }}
                                        the_filename={f.rs_filename}
                                        type="rs"
                                        accept="application/pdf,image/*"
                                        // fileType="application/pdf"
                                        disabled={props.disabled ? true : false}
                                    />

                                    <CustomInput 
                                        value={f.description}
                                        onChange={(e) => {
                                            const newData = clone(data);
                                            if (!newData.documents) newData.documents = [];
                                            newData.documents = newData.documents.map((ff,ii) => {
                                                if (ii === i) {
                                                    ff.description = e.target.value;
                                                    return ff;
                                                }
                                                return ff;
                                            })
                                            props.updateDataObj('documents', newData.documents);
                                        }}
                                        label="Description"
                                        disabled={props.disabled ? true : false}
                                    />
                                </div>
                            </div>
                        </GridItem>
                        })
                    }
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    )

}

export default Documents2;